import React, { useContext, useEffect, useMemo, useState } from 'react'
import Accordion from '../../atoms/Accordion/Accordion'
import Button from '../../atoms/Button/Button'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import { Bin, CartNormal, Edit, Info } from '../../atoms/NewIcons'
import { Trans } from '../../atoms'
import useTrans from '../../../hooks/useTrans'
import { useRouter } from 'next/router'
import { handleScrollRef, priceNotation } from '../../../utils/safe'
import LoadingSvg from '../../atoms/Loading/Loading'
import { useSelector } from 'react-redux'
import { ProdottoContext } from '../../../context/ProdottoContext'
import { getIgnoraMinimiStampa, showButtonsRiepilogo } from '../../../utils/servicegift'
import {
  trackingAddCart,
  trackingCreaOfferta,
  trackingGAEvent,
  trackingModificaProdotti,
  trackingOrdinaSubito,
  trackingSalvaPerDopo,
} from '../../../utils/gtm'
import NewModal from '../NewModal/NewModal'

const OrdineRiepilogoCard = ({
  ordine,
  isCheckout,
  isOrdine,
  AddToCartMain,
  SaveLater,
  isProdotto,
  prodotto,
  ModificaArticoli,
  onCheckout,
  disabledCheckout,
  ConfermaOrdine,
  setEditArticoloProps,
  isLoading,
  carrelloCheckout,
  OrdinaSubito,
  isSubmitting,
  isPromoValida,
  variant,
  disabledActions,
  aggiornaPreventivo,
  isPreventivoFormValid,
  quantitaTotale,
}) => {
  const t = useTrans()
  const router = useRouter()
  const [altriCosti, setAltriCosti] = useState(0)
  const [costiTrasporto, setCostiTrasporto] = useState(0)
  const [costiRitiro, setCostiRitiro] = useState(0)
  const [scontiTotale, setScontiTotale] = useState(0)
  const [disabled, setDisabled] = useState(true)
  const [disabledModificaArticoli, setDisabledModificaArticoli] = useState(true)
  const [expanded, setExpanded] = useState(false)
  const { service_gift } = useSelector((state) => state?.servicegift)
  const { utente } = useSelector((state) => state?.utente)
  const prodottoContext = useContext(ProdottoContext)
  const [isDebugVisibile, setDebugVisible] = useState(false)

  const setDisabledAll = (value) => {
    setDisabled(value)
    setDisabledModificaArticoli(value)
  }

  useEffect(() => {
    if (ordine) {
      setDisabledAll(false)
      setCostiTrasporto(ordine.valore_trasporto ? ordine.valore_trasporto : 0)
      setCostiRitiro(ordine.valore_ritiro ? ordine.valore_ritiro : 0)
      setAltriCosti(
        ordine.valore_impianto +
          ordine.valore_gestione +
          ordine.valore_siae +
          ordine?.valore_supplementi_minimi_stampa +
          ordine?.valore_tracciatura_logo
      )
      setScontiTotale(
        ordine.valore_sconto_merce +
          ordine.valore_sconto_personalizzazione +
          ordine.valore_sconto_gestione +
          ordine.valore_sconto_impianto +
          ordine.valore_sconto_trasporto +
          ordine.valore_sconto_imballi_integri
      )
    } else {
      setCostiTrasporto(0)
      setCostiRitiro(0)
      setAltriCosti(0)
      setScontiTotale(0)
    }

    !ordine && setDisabledAll(true)

    // Solo quando istanziato in ProdottoTemplate
    if (ordine && prodottoContext) {
      let quantitaInsufficiente,
        disabled = false

      ordine.personalizzazioni_carrello.map((personalizzazione_carrello) => {
        const quantita = personalizzazione_carrello.quantita_personalizzazione
        if (
          !(
            quantita >= prodotto?.quantita_minima_personalizzabile ||
            getIgnoraMinimiStampa(utente, service_gift)
          )
        ) {
          quantitaInsufficiente = true
          disabled = true
        }
      })

      if (
        ordine.personalizzazioni_carrello.length == 0 &&
        ordine.righe_carrello.length == 0 &&
        ordine.righe_carrello_merce_neutra.length == 0
      ) {
        disabled = true
      }

      // console.log("RiepilogoOrdine", ordine, quantitaInsufficiente, disabled)
      // // mostro solo il primo modale se sono presenti entrambi gli errori
      // prodottoContext?.setShowQuantitaInsufficiente(quantitaInsufficiente)
      setDisabledAll(disabled)
    }
  }, [ordine])

  const RigheConfezionamento = (ordine) => {
    return ordine?.personalizzazioni_carrello?.map(
      (riga) =>
        riga.totale_confezionamento > 0 && (
          <>
            <div className="riepilogo-card__accordion-row">
              <p>{riga?.nome_lavorazione}</p>
            </div>

            {riga?.righe_carrello?.map((item) => (
              <div className="riepilogo-card__accordion-row" key={item.id}>
                <div className="riepilogo-card__accordion-label">
                  <p>
                    {item?.articolo?.codice + ' '} x {item?.quantita} pz
                  </p>
                </div>
                <div className="riepilogo-card__accordion-price">
                  {priceNotation(item?.prezzo_confezionamento * item?.quantita.toFixed(3), 2)} €
                </div>
              </div>
            ))}
          </>
        )
    )
  }

  const Lavorazione = (item) => {
    let pers = (
      <>
        {item.nome_lavorazione && ['carrello', 'checkout'].includes(variant) && (
          <div className="riepilogo-card__accordion-row">
            <div className="riepilogo-card__accordion-code">{item.nome_lavorazione}</div>
          </div>
        )}

        {item?.righe_carrello?.map((element) => (
          <div className="riepilogo-card__accordion-row">
            <div className="riepilogo-card__accordion-code">{element.articolo.codice}</div>
            <div className="riepilogo-card__accordion-qty">
              x {element.quantita} {t('pz')}
            </div>
            <div className="riepilogo-card__accordion-price">
              {priceNotation(element.totale_personalizzazione, 2)} €
            </div>
          </div>
        ))}
      </>
    )
    return pers
  }

  const promozioneApplicataRighe = useMemo(() => {
    return ordine?.righe_carrello?.find((item) => item.promozioni_applicate?.length > 0)
      ?.promozioni_applicate?.[0]
  }, [ordine])

  return (
    <>
      {expanded && (
        <div className="riepilogo-card-overlay" onClick={() => setExpanded(false)}></div>
      )}
      <div
        className={`riepilogo-card ${isProdotto && 'riepilogo-card--prodotto'} ${
          expanded && ' riepilogo-card--expanded'
        }`}
      >
        <div className="riepilogo-card__icon-container" onClick={() => setExpanded(!expanded)}>
          <CartNormal />
        </div>
        <div className="riepilogo-card__content">
          <div className="riepilogo-card__head" onClick={() => setExpanded(!expanded)}>
            <p className="riepilogo-card__title">
              {isProdotto ? <>{t('Calcolo preventivo')}</> : <>{t('Riepilogo Ordine')}</>}
            </p>
            <p className="riepilogo-card__subtitle">
              {isProdotto && !ordine?.totale ? (
                <>
                  <Trans chiave="Codice articolo" /> {prodotto.codice}
                </>
              ) : (
                <>
                  <span>
                    <Trans chiave="Totale" />:{' '}
                  </span>
                  <span>{priceNotation(ordine?.totale, 2)} €</span>
                </>
              )}
            </p>
            {promozioneApplicataRighe && (
              <p className="riepilogo-card__disclaimer">
                {t(
                  'Gli sconti visualizzati sono da intendersi già applicati al valore e al totale della merce'
                )}
              </p>
            )}
          </div>
          {isLoading ? (
            <div className="riepilogo-card__loading">
              <LoadingSvg width={50} height={50} />
            </div>
          ) : (
            <>
              <div className="riepilogo-card__rows-container">
                {!aggiornaPreventivo && (
                  <>
                    <div className="riepilogo-card__rows-container--child">
                      {ordine?.righe_carrello_merce_neutra?.length > 0 ||
                      ordine?.righe_carrello?.length > 0 ||
                      ordine?.personalizzazioni_carrello?.length > 0 ? (
                        <div className="riepilogo-card__row riepilogo-card__row--accordion">
                          <Accordion
                            withoutBorder
                            placeholder={t('Merce Neutra')}
                            size="small"
                            placeholderEllipses={true}
                            className="riepilogo-card__accordion"
                            defaultOpen={promozioneApplicataRighe ? true : false}
                          >
                            {variant === 'carrello' &&
                              ordine?.righe_carrello_merce_neutra?.map((item) => (
                                <div className="riepilogo-card__accordion-row" key={item.id}>
                                  <div className="riepilogo-card__accordion-code">
                                    {item.articolo.codice}
                                  </div>
                                  <div className="riepilogo-card__accordion-qty">
                                    x {item.quantita} pz
                                  </div>
                                  <div className="riepilogo-card__accordion-price">
                                    {priceNotation(item.totale, 2)} €
                                  </div>
                                  {!isCheckout && setEditArticoloProps && (
                                    <div className="riepilogo-card__accordion-actions">
                                      {/* TODO: non dovrebbe servire con la nuova gestione
                                  <div
                                    onClick={() => {
                                      const selected = prodotto.articoli.filter(
                                        (articolo) => articolo?.codice === item.articolo?.codice
                                      )[0]

                                      setEditArticoloProps({
                                        initialStep: 1,
                                        initialSelectedArticolo: selected,
                                        show: true,
                                        initialId: item.id,
                                        initialQuantita: item.quantita,
                                      })
                                    }}
                                  >
                                    <Edit />
                                  </div> */}
                                      <div
                                        onClick={() => {
                                          setEditArticoloProps((prev_state) => ({
                                            ...prev_state,
                                            initialId: item.id,
                                            show_delete: true,
                                          }))
                                        }}
                                      >
                                        <Bin />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            {ordine?.righe_carrello?.length > 0
                              ? ordine?.righe_carrello?.map((item) => (
                                  <div className="riepilogo-card__accordion-row">
                                    <div className="riepilogo-card__accordion-code">
                                      {item.articolo.codice}
                                    </div>
                                    <div className="riepilogo-card__accordion-qty">
                                      x {item.quantita} pz
                                    </div>
                                    <div className="riepilogo-card__accordion-price">
                                      {priceNotation(item.totale, 2)} €{' '}
                                      <span className="riepilogo-card__accordion-price-sconto">
                                        {item.promozioni_applicate?.length > 0 && (
                                          <>
                                            (
                                            <span>
                                              -
                                              {item.promozioni_applicate?.[0]
                                                .application_logics?.[0].is_percentage ? (
                                                <>
                                                  {
                                                    item.promozioni_applicate?.[0]
                                                      .application_logics?.[0].value
                                                  }
                                                  %
                                                </>
                                              ) : (
                                                <>
                                                  {priceNotation(
                                                    item.promozioni_applicate?.[0]
                                                      .application_logics?.[0].value,
                                                    2
                                                  )}
                                                  €
                                                </>
                                              )}
                                              *
                                            </span>
                                            )
                                          </>
                                        )}
                                      </span>
                                    </div>
                                    {!isCheckout && setEditArticoloProps && (
                                      <div className="riepilogo-card__accordion-actions">
                                        {/* TODO: non dovrebbe servire con la nuova gestione
                                    <div
                                      onClick={() => {
                                        const selected = prodotto.articoli.filter(
                                          (articolo) => articolo?.codice === item.articolo?.codice
                                        )[0]

                                        setEditArticoloProps({
                                          initialStep: 1,
                                          initialSelectedArticolo: selected,
                                          show: true,
                                          initialId: item.id,
                                          initialQuantita: item.quantita,
                                        })
                                      }}
                                    >
                                      <Edit />
                                    </div> */}
                                        <div
                                          onClick={() => {
                                            setEditArticoloProps((prev_state) => ({
                                              ...prev_state,
                                              initialId: item.id,
                                              show_delete: true,
                                            }))
                                          }}
                                        >
                                          <Bin />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ))
                              : ordine?.personalizzazioni_carrello?.map((item) =>
                                  item.righe_carrello.map((element) => (
                                    <div className="riepilogo-card__accordion-row">
                                      <div className="riepilogo-card__accordion-code">
                                        {element.articolo.codice}
                                      </div>
                                      <div className="riepilogo-card__accordion-qty">
                                        x {element.quantita} {t('pz')}
                                      </div>
                                      <div className="riepilogo-card__accordion-price">
                                        {priceNotation(element.totale, 2)} €{' '}
                                        <span className="riepilogo-card__accordion-price-sconto">
                                          {item.promozioni_applicate?.length > 0 && (
                                            <>
                                              (
                                              <span>
                                                -
                                                {item.promozioni_applicate?.[0]
                                                  .application_logics?.[0].is_percentage ? (
                                                  <>
                                                    {
                                                      item.promozioni_applicate?.[0]
                                                        .application_logics?.[0].value
                                                    }
                                                    %
                                                  </>
                                                ) : (
                                                  <>
                                                    {priceNotation(
                                                      item.promozioni_applicate?.[0]
                                                        .application_logics?.[0].value,
                                                      2
                                                    )}
                                                    €
                                                  </>
                                                )}
                                                *
                                              </span>
                                              )
                                            </>
                                          )}
                                        </span>
                                      </div>
                                      {!isCheckout && setEditArticoloProps && (
                                        <div className="riepilogo-card__accordion-actions">
                                          {/* TODO: non dovrebbe servire con la nuova gestione
                                      <div
                                        onClick={() => {
                                          const selected = prodotto.articoli.filter(
                                            (articolo) =>
                                              articolo?.codice === element.articolo?.codice
                                          )[0]

                                          setEditArticoloProps({
                                            initialStep: 1,
                                            initialSelectedArticolo: selected,
                                            show: true,
                                            initialId: element.id,
                                            initialQuantita: element.quantita,
                                          })
                                        }}
                                      >
                                        <Edit />
                                      </div> */}
                                          <div
                                            onClick={() => {
                                              setEditArticoloProps((prev_state) => ({
                                                ...prev_state,
                                                initialId: element.id,
                                                show_delete: true,
                                              }))
                                            }}
                                          >
                                            <Bin />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  ))
                                )}

                            {promozioneApplicataRighe && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-sconto-disclaimer">
                                  *
                                  {promozioneApplicataRighe.application_logics?.[0]
                                    .is_percentage ? (
                                    <>
                                      {t('Sconto applicato del')}{' '}
                                      {promozioneApplicataRighe.application_logics?.[0].value}%
                                    </>
                                  ) : (
                                    <>
                                      {t('Sconto applicato di')}{' '}
                                      {priceNotation(
                                        promozioneApplicataRighe.application_logics?.[0].value,
                                        2
                                      )}
                                      €
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                          </Accordion>
                          <p className="riepilogo-card__price">
                            {priceNotation(ordine?.valore_merce, 2)} €
                          </p>
                        </div>
                      ) : (
                        <div className="riepilogo-card__row">
                          <p>{t('Merce Neutra')}</p>
                          <p className="riepilogo-card__price">
                            {priceNotation(ordine?.valore_merce, 2)} €
                          </p>
                        </div>
                      )}

                      {(ordine?.righe_carrello?.filter(
                        (item) => item.personalizzazione_carrello != null
                      ).length > 0 ||
                        ordine?.personalizzazioni_carrello?.length > 0) && (
                        <div className="riepilogo-card__row riepilogo-card__row--accordion">
                          <Accordion
                            withoutBorder
                            placeholder={t('Personalizzazione')}
                            size="small"
                            placeholderEllipses={true}
                            className="riepilogo-card__accordion"
                          >
                            {variant === 'checkout' && isOrdine
                              ? carrelloCheckout?.personalizzazioni_carrello?.map((item) =>
                                  Lavorazione(item)
                                )
                              : ordine?.personalizzazioni_carrello?.length > 0
                              ? ordine?.personalizzazioni_carrello?.map((item) => Lavorazione(item))
                              : ordine?.righe_carrello
                                  ?.filter((item) => item.personalizzazione_carrello != null)
                                  .map((item) => Lavorazione(item))}
                          </Accordion>
                          <p className="riepilogo-card__price">
                            {priceNotation(ordine?.valore_personalizzazione, 2)} €
                          </p>
                        </div>
                      )}

                      {/* Inserito Nuovo Confezionamento */}
                      {ordine?.valore_confezionamento > 0 && (
                        <div className="riepilogo-card__row riepilogo-card__row--accordion">
                          <Accordion
                            withoutBorder
                            placeholder={t('Confezionamento')}
                            size="small"
                            placeholderEllipses={true}
                            className="riepilogo-card__accordion"
                          >
                            {isCheckout
                              ? RigheConfezionamento(carrelloCheckout)
                              : ordine?.personalizzazioni_carrello?.map(
                                  (riga) =>
                                    riga.totale_confezionamento > 0 && (
                                      <>
                                        <div className="riepilogo-card__accordion-row">
                                          <p>{riga?.nome_lavorazione}</p>
                                        </div>

                                        {riga?.righe_carrello?.map((item) => (
                                          <div className="riepilogo-card__accordion-row">
                                            <div className="riepilogo-card__accordion-label">
                                              <p>
                                                {item?.articolo?.codice + ' '} x {item?.quantita} pz
                                              </p>
                                            </div>
                                            <div className="riepilogo-card__accordion-price">
                                              {priceNotation(
                                                item?.prezzo_confezionamento * item?.quantita,
                                                2
                                              )}{' '}
                                              €
                                            </div>
                                          </div>
                                        ))}
                                      </>
                                    )
                                )}
                          </Accordion>
                          <p className="riepilogo-card__price">
                            {priceNotation(ordine?.valore_confezionamento, 2)} €
                          </p>
                        </div>
                      )}
                      {altriCosti != 0 && (
                        <div className="riepilogo-card__row riepilogo-card__row--accordion">
                          <Accordion
                            withoutBorder
                            placeholder={t('Altri Costi')}
                            size="small"
                            placeholderEllipses={true}
                            className="riepilogo-card__accordion"
                          >
                            {ordine?.valore_impianto > 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Impianto" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_impianto, 2)} €
                                </div>
                              </div>
                            )}
                            {ordine?.valore_gestione > 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Avviamento" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_gestione, 2)} €
                                </div>
                              </div>
                            )}

                            {ordine?.valore_siae > 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="SIAE" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_siae, 2)} €
                                </div>
                              </div>
                            )}

                            {ordine?.valore_supplementi_minimi_stampa > 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Sotto-minimo stampa" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_supplementi_minimi_stampa, 2)} €
                                </div>
                              </div>
                            )}

                            {ordine?.valore_tracciatura_logo > 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Tracciatura logo" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_tracciatura_logo, 2)} €
                                </div>
                              </div>
                            )}
                          </Accordion>
                          <p className="riepilogo-card__price">{priceNotation(altriCosti, 2)} €</p>
                        </div>
                      )}
                      {ordine && scontiTotale != 0 && (
                        <div className="riepilogo-card__row riepilogo-card__row--accordion">
                          <Accordion
                            withoutBorder
                            placeholder={t('Sconti')}
                            size="small"
                            placeholderEllipses={true}
                            className="riepilogo-card__accordion"
                          >
                            {ordine?.valore_sconto_imballi_integri != 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Sconto imballi" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_sconto_imballi_integri, 2)} €
                                </div>
                              </div>
                            )}
                            {ordine?.valore_sconto_merce != 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Sconto Merce Neutra" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_sconto_merce, 2)} €
                                </div>
                              </div>
                            )}
                            {ordine?.valore_sconto_personalizzazione != 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Sconto personalizzazione" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_sconto_personalizzazione, 2)} €
                                </div>
                              </div>
                            )}
                            {ordine?.valore_sconto_gestione != 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Sconto avviamento" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_sconto_gestione, 2)} €
                                </div>
                              </div>
                            )}
                            {ordine?.valore_sconto_impianto != 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Sconto impianti" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_sconto_impianto, 2)} €
                                </div>
                              </div>
                            )}
                            {ordine?.valore_sconto_trasporto != 0 && (
                              <div className="riepilogo-card__accordion-row">
                                <div className="riepilogo-card__accordion-label">
                                  <Trans chiave="Sconto spedizione" />
                                </div>
                                <div className="riepilogo-card__accordion-price">
                                  {priceNotation(ordine?.valore_sconto_trasporto, 2)} €
                                </div>
                              </div>
                            )}
                          </Accordion>
                          <p className="riepilogo-card__price">
                            {scontiTotale != 0 && <>{priceNotation(scontiTotale, 2)} €</>}
                          </p>
                        </div>
                      )}

                      <div className="riepilogo-card__row">
                        <div>
                          {costiRitiro ? t('Ritiro') : t('Spedizione')}{' '}
                          <span className="riepilogo-card__spedizione-info">
                            {!isCheckout && !costiRitiro && (
                              <Tooltip
                                label={t(
                                  'Il calcolo del trasporto è indicativo sulla base degli articoli presenti nel preventivo e della destinazione principale'
                                )}
                                id={'tt-ordineriepilogocard-spedizione'}
                                size="sm"
                              >
                                <Info />
                              </Tooltip>
                            )}
                          </span>{' '}
                        </div>
                        <p>{priceNotation(costiRitiro ? costiRitiro : costiTrasporto, 2)} €</p>
                      </div>

                      {ordine?.totale_imponibile > 0 && (
                        <div className="riepilogo-card__row">
                          <p>{t('Totale Netto')}</p>
                          <p>{priceNotation(ordine?.totale_imponibile, 2)} €</p>
                        </div>
                      )}
                      {ordine?.totale_imposta > 0 && (
                        <div className="riepilogo-card__row">
                          <p>{t('IVA')}</p>
                          <p>{priceNotation(ordine?.totale_imposta, 2)} €</p>
                        </div>
                      )}
                    </div>
                    <div className="riepilogo-card__totale">
                      <div className="riepilogo-card__row riepilogo-card__row--totale">
                        <p>{t('Totale')}</p>
                        <p>{priceNotation(ordine?.totale, 2)} €</p>
                      </div>
                    </div>
                  </>
                )}
                {aggiornaPreventivo && (
                  <div className="riepilogo-card__aggiorna-preventivo">
                    {<Info />}
                    <span>{t('Aggiorna il preventivo per vedere le modifiche')}</span>
                  </div>
                )}
                {aggiornaPreventivo && Number(quantitaTotale) === 0 && (
                  <div className="riepilogo-card__aggiorna-preventivo riepilogo-card__aggiorna-preventivo--error">
                    <Info />
                    <span>{t('Inserire minimo un articolo in un colore')}</span>
                  </div>
                )}
                {!aggiornaPreventivo &&
                  (!!ordine?.data_partenza_spedizione || !!ordine?.giorni_lavorazione) &&
                  !service_gift && (
                    <div className="riepilogo-card__consegna-prevista">
                      {!!ordine?.giorni_lavorazione && ordine?.data_partenza_spedizione && (
                        <div className="riepilogo-card__consegna-prevista__content">
                          <p className="riepilogo-card__consegna-prevista__label">
                            {t('Tempo di lavorazione (giorni)')}
                          </p>
                          <p className="riepilogo-card__consegna-prevista__value">
                            {ordine?.giorni_lavorazione}
                          </p>
                        </div>
                      )}
                      <div className="riepilogo-card__consegna-prevista__content">
                        <p className="riepilogo-card__consegna-prevista__label">
                          {t('Partenza spedizione')}
                        </p>
                        <div className="riepilogo-card__consegna-prevista__merce_personalizzata">
                          {ordine?.valore_personalizzazione > 0 && (
                            <Tooltip
                              label={
                                ordine?.data_partenza_spedizione
                                  ? t(
                                      'Data di partenza della spedizione potrebbe variare in base alla data di approvazione della bozza digitale o del campione fisico'
                                    )
                                  : 'TBD'
                              }
                            >
                              <Info />
                            </Tooltip>
                          )}
                        </div>
                        <p className="riepilogo-card__consegna-prevista__value">
                          {ordine?.data_partenza_spedizione || t('Da definire')}
                        </p>
                      </div>
                    </div>
                  )}
                {service_gift && isCheckout && !!ordine?.data_consegna_prevista && (
                  <div className="riepilogo-card__consegna-prevista">
                    <div className="riepilogo-card__consegna-prevista__content">
                      <p className="riepilogo-card__consegna-prevista__label">
                        {t('Partenza spedizione')}
                      </p>
                      <div className="riepilogo-card__consegna-prevista__merce_personalizzata">
                        {ordine?.valore_personalizzazione > 0 && (
                          <Tooltip
                            label={t(
                              'Data di partenza della spedizione potrebbe variare in base alla data di approvazione della bozza digitale o del campione fisico'
                            )}
                          >
                            <Info />
                          </Tooltip>
                        )}
                      </div>
                      <p className="riepilogo-card__consegna-prevista__value">
                        {ordine?.data_consegna_prevista}
                      </p>
                    </div>
                  </div>
                )}
                {!aggiornaPreventivo && !!ordine?.leadtime_debug_trace?.length && (
                  <div className="riepilogo-card__consegna-prevista__content">
                    <Button
                      className="riepilogo-card__debug__cta"
                      onClick={() => setDebugVisible(true)}
                      label="DEBUG ALGORITMO"
                      variant="ghost"
                      size="small"
                    />
                  </div>
                )}
                {variant === 'checkout' ? (
                  <div className="riepilogo-card__buttons">
                    {
                      <Button
                        loading={isSubmitting}
                        onClick={() => {
                          trackingGAEvent('confirm_order_cta')
                          ConfermaOrdine()
                        }}
                        label={t('Conferma Ordine')}
                        disabled={!isOrdine}
                        variant="primary"
                        size="medium"
                        className="riepilogo-card__button"
                      />
                    }
                  </div>
                ) : variant === 'prodotto' || variant === 'personalizzazione' ? (
                  <div className="riepilogo-card__buttons">
                    {showButtonsRiepilogo(utente, service_gift) && (
                      <>
                        {!disabledActions && (
                          <Button
                            disabled={disabled}
                            label={t('Aggiungi al carrello')}
                            variant="primary"
                            size="medium"
                            onClick={() => {
                              AddToCartMain()
                              trackingAddCart(ordine, 'standard_order')
                            }}
                            className="riepilogo-card__button riepilogo-card__button--addcart"
                          />
                        )}
                        {!!aggiornaPreventivo && (
                          <Button
                            label={t('Aggiorna preventivo')}
                            variant="primary-gradient"
                            size="medium"
                            onClick={() => {
                              aggiornaPreventivo()
                              const el = document.getElementById('configurazione-prodotto__buttons')
                              handleScrollRef(el, -150, true)
                            }}
                            className="riepilogo-card__button riepilogo-card__button--addcart"
                            disabled={!isPreventivoFormValid}
                          />
                        )}
                        {ordine?.checkout_rapido_abilitato &&
                          !aggiornaPreventivo &&
                          !disabledActions &&
                          !!OrdinaSubito &&
                          variant !== 'personalizzazione' && (
                            <Button
                              disabled={disabled}
                              label={t('Ordina subito')}
                              variant="primary"
                              size="medium"
                              onClick={() => {
                                trackingOrdinaSubito(ordine)
                                OrdinaSubito()
                              }}
                              className="riepilogo-card__button riepilogo-card__button--addcart"
                            />
                          )}
                        {ordine?.righe_carrello?.length > 0 &&
                          !service_gift &&
                          variant !== 'personalizzazione' && (
                            <Button
                              label={t('Crea offerta')}
                              variant="secondary"
                              size="medium"
                              onClick={() => {
                                trackingCreaOfferta(ordine)
                                router?.push(`/crea-offerta?cart=${ordine?.id}`)
                              }}
                              className="riepilogo-card__button riepilogo-card__button--addcart"
                              disabled={disabled}
                            />
                          )}
                        {variant !== 'personalizzazione' && (
                          <Button
                            disabled={disabled}
                            label={t('Salva per dopo')}
                            variant="secondary"
                            size="medium"
                            onClick={() => {
                              trackingSalvaPerDopo(ordine)
                              SaveLater()
                            }}
                            className="riepilogo-card__button riepilogo-card__button--addcart"
                          />
                        )}
                      </>
                    )}
                    {/* TODO: non dovrebbe servire con la nuova gestione
                    {variant !== 'personalizzazione' && (
                      <Button
                        disabled={disabledModificaArticoli}
                        label={t('Modifica articoli')}
                        variant="ghost"
                        size="medium"
                        onClick={() => {
                          trackingModificaProdotti(ordine)
                          ModificaArticoli()
                        }}
                        className="riepilogo-card__button riepilogo-card__button--addcart"
                      />
                    )}
                    */}
                  </div>
                ) : variant === 'carrello' ? (
                  <div className="riepilogo-card__buttons">
                    <Button
                      disabled={disabledCheckout && disabledCheckout}
                      bg={disabledCheckout && 'grey'}
                      label={t("Prosegui con l'ordine")}
                      variant="primary"
                      size="medium"
                      onClick={() => onCheckout && onCheckout()}
                      className="riepilogo-card__button"
                    />
                    {ordine && !service_gift && (
                      <Button
                        label={t('Crea offerta')}
                        variant="secondary"
                        size="medium"
                        onClick={() => {
                          trackingCreaOfferta(ordine)
                          router?.push(`/crea-offerta?cart=${ordine?.id}`)
                        }}
                        className="riepilogo-card__button riepilogo-card__button--addcart"
                      />
                    )}
                  </div>
                ) : null}
              </div>
            </>
          )}
        </div>
      </div>
      {!!ordine?.leadtime_debug_trace?.length && (
        <NewModal
          className="riepilogo-card__debug__modal"
          visible={isDebugVisibile}
          onClose={() => setDebugVisible(false)}
        >
          {ordine?.leadtime_debug_trace.map((item) => (
            <div>
              {item.prodotto && item.nome_lavorazione && (
                <p className="riepilogo-card__debug__title">
                  Personalizzazione: {item.prodotto} - {item.nome_lavorazione}
                </p>
              )}
              <pre className="riepilogo-card__debug__content">
                <code>{item.debug_trace}</code>
              </pre>
            </div>
          ))}
        </NewModal>
      )}
    </>
  )
}

export default React.memo(OrdineRiepilogoCard)
